import { InputDate } from '@dunia/ui';
//import { InputDateCustom } from '@dunia/ui';
import * as conditions from '@/forms/conditions';

const defaultValidations = [
  {
    errorMessage: 'Please type a valid date',
    condition: conditions.isDateCondition,
    name: 'is-date',
  },
];

export default {
  name: 'DateWrapper',
  functional: true,
  defaultValidations,
  render(createElement, context) {
    return createElement(InputDate, {
      attrs: {
        'data-forced-fullwidth': context.props.dataForcedFullwidth,
      },
    });
  },
};
